import { ForestProductList } from '../../../../components/ForestProduct';

export function ForestProducts() {
  return <ForestProductList />;
}
